import { render, staticRenderFns } from "./UpdateTaxes.vue?vue&type=template&id=6844abaa"
import script from "./UpdateTaxes.vue?vue&type=script&lang=js"
export * from "./UpdateTaxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports